import AutomationsGallery from '@/components/views/AutomationsView/AutomationsGallery';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { paths } from '@/app/routes';
import { AutomationsIcon } from '@/components/icons/AutomationsIcon';
import { Box, CircularProgress, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@/components/layouts/PageHeader';

export const AutomationsView = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const { getFeatureFlags, isLoading } = useFeatureFlagContext();
	const showAutomations = Boolean(getFeatureFlags('displayAutomations')?.active);

	useEffect(() => {
		if (!isLoading && !showAutomations) {
			navigate(paths.home);
		}
	}, [isLoading, showAutomations, navigate]);

	if (isLoading) {
		return (
			<Box display='flex' justifyContent='center' mt={4}>
				<CircularProgress size={28} />
			</Box>
		);
	}

	if (!showAutomations) {
		return null;
	}

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				width: '100%',
				pt: 1,
				pb: 3,
			}}
		>
			<PageHeader
				title='Automations'
				icon={
					<AutomationsIcon
						{...(theme.palette.mode === 'dark' && { bgColor: 'transparent' })}
					/>
				}
			/>
			<Box px={3}>
				<AutomationsGallery />
			</Box>
		</Box>
	);
};
